import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Input, Button, Space, Select, Row, Col, Card, Carousel, Image } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import Newsletter from "../components/Newsletter";
import { advertisementService } from "../services/publicApi";

const Home = () => {
  const navigate = useNavigate();
  
  const [search, setSearch] = useState('');
  const [homeCategory, setHomeCategory] = useState();
  const [advertisements, setAdvertisements] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        // Charger les publicités actives
        const adResponse = await advertisementService.getActiveAdvertisements();
        setAdvertisements(adResponse || []);
      } catch (e) {
        setAdvertisements([]);
      }
    })();
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll('.reveal-on-scroll');
    if (!elements.length) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.14,
        rootMargin: '0px 0px -40px 0px'
      }
    );

    elements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, []);

  // Fonction pour naviguer vers les produits avec la catégorie sélectionnée
  const handleCategoryClick = (categoryName) => {
    // Mapper les noms d'affichage vers les slugs de catégories
    const categorySlugs = {
      'Détection incendie': 'detection-incendie',
      'Éclairage sécurité': 'eclairage-securite',
      'Onduleurs': 'onduleur',
      'Extinction automatique': 'extinction',
      'Contrôle d\'accès': 'controle-acces-pointage',
      'Vidéosurveillance': 'videosurveillance',
      'Alarmes intrusion': 'intrusion',
      'DOMOTIQUE/ GRMS': 'domotique-grms',
      'GRMS': 'domotique-grms',
      'Audio professionnel': 'sonorisation',
      'Détection de gaz': 'detection-gaz'
    };
    
    const categorySlug = categorySlugs[categoryName];
    if (categorySlug) {
      navigate(`/produits?category=${categorySlug}`);
    } else {
      navigate('/produits');
    }
  };

  const submitSearch = () => {
    const q = (search || '').trim();
    const params = new URLSearchParams();
    
    if (q) {
      params.set('search', q);
    }
    
    if (homeCategory) {
      params.set('category', homeCategory);
    }
    
    const qs = params.toString();
    navigate(qs ? `/produits?${qs}` : '/produits');
  };

  const onEnter = (e) => {
    if (e.key === 'Enter') submitSearch();
  };

  const partners = [
    { name: 'Zennio', image: '/images/ZENNIO.png' },
    { name: 'Hikvision', image: '/images/hikvision.png' },
    { name: 'Aguilera', image: '/images/aguilera.png' },
    { name: 'Cooper', image: '/images/Cooper.svg' },
    { name: 'Eaton', image: '/images/eaton.png' },
    { name: 'Sensitron', image: '/images/SENSITRON.jpg' },
    { name: 'Legrand', image: '/images/legrand.png' },
    { name: 'Nugelec', image: '/images/NUGELEC.png' },
    { name: 'HDL', image: '/images/hdl.webp' }
  ];

  const partnerSlides = [];
  for (let i = 0; i < partners.length; i += 5) {
    partnerSlides.push(partners.slice(i, i + 5));
  }
  
  // Publicités depuis l'admin, ou placeholder si aucune
  const safeAdvertisements = Array.isArray(advertisements) ? advertisements : [];
  const hasAds = safeAdvertisements.length > 0;

  const homeProducts = [
    { icon: 'fas fa-fire', label: 'Détection incendie', color: '#54ba66' },
    { icon: 'fas fa-bolt', label: 'Éclairage sécurité', color: '#54ba66' },
    { icon: 'fas fa-car-battery', label: 'Onduleurs', color: '#54ba66' },
    { icon: 'fas fa-spray-can', label: 'Extinction automatique', color: '#54ba66' },
    { icon: 'fas fa-fingerprint', label: "Contrôle d'accès", color: '#54ba66' },
    { icon: 'fas fa-camera', label: 'Vidéosurveillance', color: '#54ba66' },
    { icon: 'fas fa-shield-alt', label: 'Alarmes intrusion', color: '#54ba66' },
    { icon: 'fas fa-project-diagram', label: 'Réseaux informatiques', color: '#54ba66' },
    { icon: 'fas fa-phone-alt', label: 'Interphonie', color: '#54ba66' },
    { icon: 'fas fa-building', label: 'DOMOTIQUE/ GRMS', color: '#54ba66' },
    { icon: 'fas fa-headphones-alt', label: 'Audio professionnel', color: '#54ba66' },
    { icon: 'fas fa-smog', label: 'Détection de gaz', color: '#54ba66' }
  ];

  const referenceProjects = [
    {
      title: 'Campus des Mines Vertes',
      image: '/images/produit-image.png',
      badge: 'Campus des Mines Vertes',
      meta: 'Courant faible  •  Sécurité  •  Réseaux'
    },
    {
      title: 'Onomo Terminus',
      image: '/images/TERMINUS.jpg',
      badge: 'Onomo Terminus',
      meta: 'Vidéosurveillance  •  Réseaux  •  Sûreté'
    },
    {
      title: 'Onomo Massira',
      image: '/images/ONOMO_MASSIRA.jpg',
      badge: 'Onomo Massira',
      meta: 'Sécurité  •  Interphonie  •  Infrastructure'
    },
    {
      title: 'The View',
      image: '/images/THE_VIEW.jpeg',
      badge: 'The View',
      meta: 'Domotique  •  Réseaux  •  Supervision'
    },
    {
      title: 'Relex Hotel',
      image: '/images/RELEX_HOTEL.png',
      badge: 'Relex Hotel',
      meta: 'Audio  •  Courant faible  •  Contrôle d’accès'
    }
  ];

  const activeReferenceProject = referenceProjects[0];

  return (
    <div className="home">
      {/* Hero image Section */}
      <section className="hero-compact mt-header">
        <div className="container">
          <div className="hero-static-banner hero-video-banner">
            <video
              src="/videos/domoelec-acceuil.mp4"
              autoPlay
              muted
              loop
              playsInline
              aria-label="DOMOELEC - Solutions electriques, securite et domotique"
            />
            <div className="hero-video-overlay" aria-hidden="true"></div>
            <div className="hero-video-content">
              <h1 className="hero-video-title">
                Sécurité, Confort <span>&amp; Innovation</span>
              </h1>
              <div className="hero-video-actions">
                <Link to="/contact" className="hero-video-cta hero-video-cta--primary">
                  <i className="fas fa-headset" aria-hidden="true"></i>
                  Contactez nos Experts                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Statistics Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon" style={{ color: '#54ba66' }}>
                <i className="fas fa-tools"></i>
              </div>
              <div className="stat-text">
                <h3>500+</h3>
                <p>Installations réalisées</p>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon" style={{ color: '#54ba66' }}>
                <i className="fas fa-award"></i>
              </div>
              <div className="stat-text">
                <h3>+13 ans</h3>
                <p>D'expérience</p>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon" style={{ color: '#54ba66' }}>
                <i className="fas fa-clock"></i>
              </div>
              <div className="stat-text">
                <h3>24h</h3>
                <p>Intervention d'urgence</p>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon" style={{ color: '#54ba66' }}>
                <i className="fas fa-boxes"></i>
              </div>
              <div className="stat-text">
                <h3>+2000</h3>
                <p>Produits</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="main-content">
        <div className="container">
          <div className="content-grid">
            {/* Products Section - Nouveau style */}
            <div className="products-section-modern">
              <div className="products-modern-head reveal-on-scroll">
                <div className="products-modern-copy">
                  <span className="products-modern-kicker">Nos Produits</span>
                  <h2>
                    Nos solutions, <span>votre sécurité</span>
                  </h2>
                  <p>
                    Des solutions complètes et intégrées en courant faible pour
                    sécuriser, connecter et optimiser vos bâtiments.
                  </p>
                </div>
                <a className="products-see-all" href="/produits">
                  <span>Voir tous les produits</span>
                  <span className="products-see-all__icon">
                    <i className="fas fa-arrow-right"></i>
                  </span>
                </a>
              </div>
              <div className="products-modern-layout">
                <div className="products-modern-grid">
                  {homeProducts.map((c, index) => (
                    <div 
                      key={c.label} 
                      className="product-card-modern reveal-on-scroll" 
                      onClick={() => handleCategoryClick(c.label)}
                      style={{ cursor: 'pointer', transitionDelay: `${index * 35}ms` }}
                    >
                      <div className="pc-icon" style={{ color: c.color }}>
                        <i className={c.icon}></i>
                      </div>
                      <div className="pc-content">
                        <h3>{c.label}</h3>
                        <span className="pc-link" aria-hidden="true">
                          <i className="fas fa-arrow-right pc-link__arrow"></i>
                        </span>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="references-premium-card references-premium-card--image reveal-on-scroll">
                  <div className="references-visual">
                    <div className="references-visual-glow" aria-hidden="true"></div>
                    <div className="references-media-card">
                      <img
                        src={activeReferenceProject.image}
                        alt={activeReferenceProject.title}
                        className="references-device__image"
                        loading="lazy"
                        onError={(e) => {
                          e.currentTarget.src = '/images/COMPUS_DES_MINES_VERTES.jpeg';
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Nos partenaires */}
      <section className="partners-section">
        <div className="container">
          <div className="partners-head">
            <span className="partners-kicker">Partenaires de confiance</span>
            <h2>Nos marques partenaires</h2>
            <p>Des fabricants reconnus pour la fiabilite, l'innovation et la qualite de leurs solutions professionnelles.</p>
          </div>
          <div className="partners-carousel-shell">
            <Carousel
              autoplay
              autoplaySpeed={2800}
              speed={700}
              pauseOnHover
              dots={{ className: 'partners-dots' }}
            >
              {partnerSlides.map((slide, index) => (
                <div key={`partner-slide-${index}`}>
                  <div className="partners-grid">
                    {slide.map((partner) => (
                      <div className="partner-card" key={partner.name}>
                        <div className="partner-card__inner">
                          <img src={partner.image} alt={partner.name} />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      </section>

      {/* Nos projets - Album d'images */}
      <section id="home-projects" className="projects-section">
        <div className="container">
          <div className="projects-header">
            <h2 className="projects-title">Nos <span className="hdr-green">Projets</span></h2>
            <p className="projects-subtitle">
              Découvrez nos réalisations et installations dans le domaine du courant faible
            </p>
          </div>

          {(() => {
            const projects = [
              { id: 1, src: '/images/COMPUS_DES_MINES_VERTES.jpeg', title: 'Campus des Mines Vertes' },
              { id: 2, src: '/images/Leoni.png', title: 'Projet Leoni' },
              { id: 4, src: '/images/MYWAY.jpg', title: 'MyWay Project' },
              { id: 5, src: '/images/NRO.jpg', title: 'NRO Installation' },
              { id: 6, src: '/images/ONOMO_MASSIRA.jpg', title: 'Onomo Massira' },
              { id: 7, src: '/images/PARCELLE_O.webp', title: 'Parcelle O' },
              { id: 8, src: '/images/RELEX_HOTEL.png', title: 'Relex Hotel' },
              { id: 9, src: '/images/SEWS.jpg', title: 'SEWS Project' },
              { id: 10, src: '/images/TERMINUS.jpg', title: 'Terminus' },
              { id: 11, src: '/images/THE_VIEW.jpeg', title: 'The View' }
            ];
            const chunk = (arr, size) => arr.reduce((acc, _, i) => (i % size === 0 ? [...acc, arr.slice(i, i + size)] : acc), []);
            const slides = chunk(projects, 3);
            const [currentSlide, setCurrentSlide] = React.useState(0);
            const totalSlides = slides.length;
            const goPrev = () => setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
            const goNext = () => setCurrentSlide((prev) => (prev + 1) % totalSlides);
            return (
              <>
                <div className="projects-controls">
                  <button onClick={goPrev} aria-label="Projets précédents" className={currentSlide === 0 ? 'is-edge' : ''}>
                    <i className="fas fa-chevron-left"></i>
                  </button>
                  <div className="projects-dots">
                    {slides.map((_, i) => (
                      <span
                        key={i}
                        className={`proj-dot ${i === currentSlide ? 'active' : ''}`}
                        onClick={() => setCurrentSlide(i)}
                      />
                    ))}
                  </div>
                  <button onClick={goNext} aria-label="Projets suivants" className={currentSlide === totalSlides - 1 ? 'is-edge' : ''}>
                    <i className="fas fa-chevron-right"></i>
                  </button>
                </div>
                <div className="projects-viewport">
                  <div
                    className="projects-track"
                    style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                  >
                    {slides.map((group, slideIndex) => (
                      <div key={slideIndex} className="projects-slide">
                        <div className="projects-grid3">
                          {group.map((project) => (
                            <article key={project.id} className="project-card">
                              <div className="project-card-img">
                                <img
                                  src={encodeURI(project.src)}
                                  alt={project.title}
                                  loading="lazy"
                                  onError={(e) => { e.currentTarget.src = '/images/1.jpg'; }}
                                />
                                <div className="project-card-overlay">
                                  <h3 className="project-card-title">{project.title}</h3>
                                </div>
                              </div>
                            </article>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            );
          })()}
        </div>
      </section>

      {/* Témoignages */}
      <section className="rv-section">
        <div className="container">
          <div className="rv-header">
            <h2>Ils parlent de <span className="hdr-green">D</span>OMO<span className="hdr-green">E</span>LEC</h2>
          </div>
          {(() => {
            const reviews = [
              { id: 1, name: "Anas", initial: "A", date: "20/08/2024", note: 5, text: "Toujours au top, le site est intuitif et fonctionne de manière remarquable. BRAVO." },
              { id: 2, name: "Mohamed", initial: "M", date: "12/03/2024", note: 5, text: "Le site est bien construit, les produits se trouvent facilement. Rapide, efficace." },
              { id: 3, name: "Anissa", initial: "A", date: "10/07/2024", note: 5, text: "Le moteur de recherche fonctionne de mieux en mieux." },
              { id: 4, name: "Imane", initial: "I", date: "18/06/2024", note: 5, text: "Simple, rapide et efficace." },
              { id: 5, name: "Rachid", initial: "R", date: "02/05/2024", note: 5, text: "Equipe très pro, conseils pertinents et disponibilité." },
            ];
            const rvRef = React.createRef();
            const scrollRv = (dir) => {
              if (rvRef.current) rvRef.current.scrollBy({ left: dir * 320, behavior: 'smooth' });
            };
            return (
              <>
                <div className="rv-controls">
                  <button onClick={() => scrollRv(-1)} aria-label="Précédent"><i className="fas fa-arrow-left"></i></button>
                  <button onClick={() => scrollRv(1)} aria-label="Suivant"><i className="fas fa-arrow-right"></i></button>
                </div>
                <div className="rv-track" ref={rvRef}>
                  {reviews.map((r) => (
                    <article key={r.id} className="rv-card">
                      <div className="rv-stars">{"★".repeat(r.note)}</div>
                      <p className="rv-text">"{r.text}"</p>
                      <div className="rv-author">
                        <div className="rv-avatar">{r.initial}</div>
                        <div>
                          <strong className="rv-name">{r.name}</strong>
                          <span className="rv-date">{r.date}</span>
                        </div>
                      </div>
                    </article>
                  ))}
                </div>
              </>
            );
          })()}
        </div>
      </section>

      <Newsletter />
    </div>
  );
};

export default Home;
